import { css } from 'styled-system/css';

export const videoStyle = {
	video: css({
		_mars: {
			'&[data-pin=true]': {
				top: 'var(--single-topbar-height)',
			},
			'& .video-view': {
				mb: '6px',
			},
			'& .match-live .text-primary': {
				color: 'minus.text'
			},
			'& .icon:not(.icon--ticket-running, .icon--dropdown)': {
				color: 'whiteOpacity.100',
				width: '24px',
				height: '24px',
			},
		},
	}),
	videoBg: css({
		_mars: {
			bgColor: 'primary.900',
		},
	}),
	videoFloatBg: css({
		_mars: {
			bgColor: 'transparent',
			_landscape: {
				bgColor: 'primary.900',
			}
		}
	})
}